import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { detectSalesLang } from '../../data/salesCopy';

/**
 * Single source of truth for the footer (legal links) used on:
 * - /sales/pricing
 * - /register
 * - /privacy, /terms, /imprint, /dpa themselves (back-nav)
 *
 * Renders compact, locale-aware legal links.
 */
export default function LegalFooter({ lang: forcedLang }) {
  const { pathname } = useLocation();
  const lang = forcedLang || detectSalesLang(pathname);
  const labels = LABELS[lang] || LABELS.en;
  const linkClass = 'hover:text-foreground transition-colors';
  return (
    <footer className="border-t mt-16" data-testid="legal-footer">
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-wrap items-center justify-between gap-4 text-xs text-muted-foreground">
        <div data-testid="legal-footer-brand">
          © {new Date().getFullYear()} Mife · {labels.tagline}
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-1" data-testid="legal-footer-nav">
          <Link to="/privacy" className={linkClass} data-testid="footer-privacy">{labels.privacy}</Link>
          <Link to="/terms" className={linkClass} data-testid="footer-terms">{labels.terms}</Link>
          <Link to="/imprint" className={linkClass} data-testid="footer-imprint">{labels.imprint}</Link>
          <Link to="/dpa" className={linkClass} data-testid="footer-dpa">{labels.dpa}</Link>
          <a href="mailto:hello@mifelife.com" className={linkClass} data-testid="footer-contact">{labels.contact}</a>
        </nav>
      </div>
    </footer>
  );
}

const LABELS = {
  tr: { tagline: 'Lead bul, outreach üret, daha hızlı kapat.', privacy: 'Gizlilik', terms: 'Kullanım Şartları', imprint: 'Künye', dpa: 'DPA', contact: 'İletişim' },
  en: { tagline: 'Find leads, generate outreach, and close faster.', privacy: 'Privacy', terms: 'Terms', imprint: 'Imprint', dpa: 'DPA', contact: 'Contact' },
  de: { tagline: 'Leads finden, Outreach erstellen, schneller abschließen.', privacy: 'Datenschutz', terms: 'AGB', imprint: 'Impressum', dpa: 'AVV', contact: 'Kontakt' },
};
